function AppVersion(arg) {
    if (arg) {
        if (arg.substring) {
            var app_version_parts = arg.split('.');
            try {
                this.major = parseInt(app_version_parts[0], 10);
            }
            catch(e) {
                this.major = 0;
            }
            try {
                this.minor = parseInt(app_version_parts[1], 10);
            }
            catch(e) {
                this.minor = 0;
            }
            try {
                this.patch = parseInt(app_version_parts[2], 10);
            }
            catch(e) {
                this.patch = 0;
            }
        }
        else if (arg.toFixed) {
            this.major = arg;
        }
    }
}
AppVersion.prototype.major = 0;
AppVersion.prototype.minor = 0;
AppVersion.prototype.patch = 0;

AppVersion.prototype.toString = function() {
    return this.major + '.' + this.minor + '.' + this.patch
}

AppVersion.prototype.compare = function(other) {
    if (this.major == other.major) {
        if (this.minor == other.minor) {
            if (this.patch == other.patch) {
                return 0;
            }
            else {
                return this.patch > other.patch ? 1 : -1;
            }
        }
        else {
            return this.minor > other.minor ? 1 : -1;
        }
    }
    else {
        return this.major > other.major ? 1 : -1;
    }
}

AppVersion.prototype.isGreaterThanOrEqualTo = function(stringOrInt) {
    let other = new AppVersion(stringOrInt);
    return this.compare(other) >= 0;
}

module.exports = AppVersion;
